import { FC } from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { sanitiseHtml } from '../../utils';

const Text = styled(Typography)<TypographyProps>(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  '& p': {
    marginBottom: theme.spacing(theme.spacingSizes.sm),
  },
  '& p:last-of-type': {
    marginBottom: 0,
  },
  '& ul, & ol': {
    paddingLeft: `${theme.spacing(theme.spacingSizes.lg)} !important`,
    marginBottom: `${theme.spacing(theme.spacingSizes.sm)} !important`,
    display: 'block !important',
    listStylePosition: 'outside !important',
  },
  '& ul': {
    listStyleType: 'disc !important',
  },
  '& ol': {
    listStyleType: 'decimal !important',
  },
  '& ul li': {
    listStyleType: 'disc !important',
    display: 'list-item !important',
    marginBottom: `${theme.spacing(theme.spacingSizes.xxs)} !important`,
  },
  '& ol li': {
    listStyleType: 'decimal !important',
    display: 'list-item !important',
    marginBottom: `${theme.spacing(theme.spacingSizes.xxs)} !important`,
  },
}));

type Props = {
  text: string;
  color?: TypographyProps['color'];
  openExternalLinksInNewTab?: boolean;
  className?: string;
};

const RichText: FC<Props> = ({
  text,
  color,
  className,
  openExternalLinksInNewTab,
}) => {
  if (!text) return null;

  return (
    <Text
      className={className}
      component="div"
      variant="body2"
      {...(color ? { color } : {})}
      dangerouslySetInnerHTML={{
        __html: sanitiseHtml(text, { openExternalLinksInNewTab }) ?? '',
      }}
    />
  );
};

export default RichText;
